/*
 * Packs de variantes de un producto (ej. muselinas: pack de 2 y pack de 4), configurados en la app
 * Happymami → Bundles con «Variantes de un producto».
 *
 * La app solo dice qué variantes ofrece cada pack. El precio es siempre el de la variante en Shopify (ya en
 * la moneda del mercado): aquí no se calcula nada. Se muestra una fila por pack y, al elegir una, el selector
 * de variantes de siempre solo enseña las de ese pack. Si el producto no tiene packs, no se toca nada.
 */
(function () {
  'use strict';

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function init() {
    var picker = document.querySelector('variant-selects, variant-radios');
    var info = document.querySelector('.product__info-container');
    if (!picker || !info || info.dataset.hmVp === '1') return;
    var handle = picker.getAttribute('data-product-handle');
    var productId = picker.getAttribute('data-product-id');
    if (!handle || !productId) return;
    info.dataset.hmVp = '1';

    var locale = (document.documentElement.lang || 'es').toLowerCase();
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    var state = { packs: [], variants: {}, pack: '', hold: 0 };
    var box = null;

    function money(cents) {
      try {
        return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(cents / 100);
      } catch (e) {
        return (cents / 100).toFixed(2) + ' ' + currency;
      }
    }

    function currentVariantId() {
      var input = document.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
      return input ? String(input.value) : '';
    }

    function packOf(variantId) {
      for (var i = 0; i < state.packs.length; i += 1) {
        if (state.packs[i].variants.indexOf(String(variantId)) !== -1) return state.packs[i];
      }
      return null;
    }

    function current() {
      for (var i = 0; i < state.packs.length; i += 1) {
        if (state.packs[i].id === state.pack) return state.packs[i];
      }
      return null;
    }

    // Precio de la fila: el de la variante más barata del pack, con su precio original si lo tiene.
    function priceOf(pack) {
      var best = null;
      pack.variants.forEach(function (id) {
        var variant = state.variants[id];
        if (variant && (!best || variant.price < best.price)) best = variant;
      });
      if (!best) return null;
      return {
        price: money(best.price),
        compare: best.compare_at_price && best.compare_at_price > best.price ? money(best.compare_at_price) : '',
      };
    }

    // Estilo de la fila que se edita en la app: borde, badge, texto inferior y tamaños (vacío = el del tema).
    function styleRow(node, pack) {
      [
        ['--hm-vp-border', pack.borderColor],
        ['--hm-vp-badge-bg', pack.badgeColor],
        ['--hm-vp-banner-bg', pack.bannerColor],
        ['--hm-vp-badge-size', pack.badgeSize ? pack.badgeSize + 'px' : ''],
        ['--hm-vp-banner-size', pack.bannerSize ? pack.bannerSize + 'px' : ''],
        ['--hm-vp-sub-size', pack.subtitleSize ? pack.subtitleSize + 'px' : ''],
      ].forEach(function (rule) {
        if (rule[1]) node.style.setProperty(rule[0], rule[1]);
      });
    }

    function render() {
      if (!box) return;
      box.textContent = '';
      state.packs.forEach(function (pack) {
        var row = el('button', 'hm-vp__row' + (pack.id === state.pack ? ' is-selected' : ''));
        row.type = 'button';
        row.setAttribute('aria-pressed', pack.id === state.pack ? 'true' : 'false');
        row.style.setProperty('--hm-vp-accent', pack.color || '#f49898');
        styleRow(row, pack);
        if (pack.badge) row.appendChild(el('span', 'hm-vp__badge', pack.badge));
        var name = el('span', 'hm-vp__name', pack.title);
        if (pack.subtitle) name.appendChild(el('span', 'hm-vp__sub', pack.subtitle));
        row.appendChild(name);
        var prices = priceOf(pack);
        if (prices) {
          var price = el('span', 'hm-vp__price');
          if (prices.compare) price.appendChild(el('s', 'hm-vp__was', prices.compare));
          price.appendChild(el('strong', '', prices.price));
          row.appendChild(price);
        }
        if (pack.banner) row.appendChild(el('span', 'hm-vp__banner', pack.banner));
        row.addEventListener('click', function () {
          choose(pack.id);
        });
        box.appendChild(row);
      });
    }

    // Valores permitidos por opción (1, 2, 3) según las variantes del pack elegido.
    function allowed(pack) {
      var sets = [{}, {}, {}];
      pack.variants.forEach(function (id) {
        var variant = state.variants[id];
        if (!variant) return;
        [variant.option1, variant.option2, variant.option3].forEach(function (value, index) {
          if (value != null) sets[index][value] = true;
        });
      });
      return sets;
    }

    function filterPicker() {
      var pack = current();
      var live = document.querySelector('variant-selects, variant-radios');
      if (!pack || !live) return;
      var sets = allowed(pack);
      live.querySelectorAll('fieldset').forEach(function (fieldset, index) {
        var allow = sets[index] || {};
        fieldset.querySelectorAll('input[type="radio"]').forEach(function (input) {
          var show = !!allow[input.value];
          input.classList.toggle('hm-vp-hidden', !show);
          var label = fieldset.querySelector('label[for="' + input.id + '"]');
          if (label) label.classList.toggle('hm-vp-hidden', !show);
        });
      });
      live.querySelectorAll('select').forEach(function (select, index) {
        var allow = sets[index] || {};
        Array.prototype.forEach.call(select.options, function (option) {
          option.hidden = !allow[option.value];
          option.disabled = option.disabled || !allow[option.value];
        });
      });
    }

    // Si la variante elegida no es de este pack, se pasa a la primera disponible del pack.
    function moveToPack(pack) {
      if (pack.variants.indexOf(currentVariantId()) !== -1) return;
      // Dawn tarda un instante en actualizar la variante: mientras tanto no se vuelve a deducir el pack de ella.
      state.hold = Date.now() + 3000;
      var target = null;
      pack.variants.forEach(function (id) {
        var variant = state.variants[id];
        if (variant && variant.available && !target) target = variant;
      });
      if (!target) target = state.variants[pack.variants[0]];
      if (!target) return;
      var live = document.querySelector('variant-selects, variant-radios');
      if (!live) return;
      [target.option1, target.option2, target.option3].forEach(function (value, index) {
        if (value == null) return;
        var fieldset = live.querySelectorAll('fieldset')[index];
        var input = fieldset && Array.prototype.find.call(fieldset.querySelectorAll('input[type="radio"]'), function (item) {
          return item.value === value;
        });
        if (input) {
          input.click();
          return;
        }
        var select = live.querySelectorAll('select')[index];
        if (select) {
          select.value = value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    function choose(id) {
      state.pack = id;
      var pack = current();
      if (pack) moveToPack(pack);
      render();
      filterPicker();
    }

    // Dawn vuelve a pintar el selector al cambiar de variante: hay que dejar la fila y el filtro como estaban.
    function ensure() {
      var live = document.querySelector('variant-selects, variant-radios');
      if (!live) return;
      if (!box || !box.isConnected) {
        box = el('div', 'hm-vp');
        live.parentNode.insertBefore(box, live);
        render();
      }
      var owner = packOf(currentVariantId());
      if (owner && owner.id !== state.pack && Date.now() > state.hold) {
        state.pack = owner.id;
        render();
      }
      filterPicker();
    }

    var queued = false;
    var observer = new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        ensure();
      });
    });

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.slice(-1) !== '/') root += '/';
    var packsUrl =
      '/apps/hm-menus/bundles?product=' + encodeURIComponent(productId) +
      '&locale=' + encodeURIComponent(document.documentElement.lang || 'es') + '&mode=variants';
    Promise.all([
      fetch(packsUrl, { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) {
        return r.ok ? r.json() : null;
      }),
      // Con el prefijo del idioma (/fr/...) el .js devuelve los valores de opción traducidos, que son los de los radios de la página.
      fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } }).then(function (r) {
        return r.ok ? r.json() : null;
      }),
    ])
      .then(function (results) {
        var data = results[0];
        var product = results[1];
        if (!data || !data.packs || !data.packs.length || !product) return;
        product.variants.forEach(function (variant) {
          state.variants[String(variant.id)] = variant;
        });
        // Solo packs con alguna variante que exista en el producto, y sin variantes ajenas.
        state.packs = data.packs
          .map(function (pack) {
            pack.variants = pack.variants.filter(function (id) {
              return !!state.variants[id];
            });
            return pack;
          })
          .filter(function (pack) {
            return pack.variants.length;
          });
        if (!state.packs.length) return;
        // Un enlace con ?variant= manda; sin él se parte del pack preseleccionado en la app.
        var owner = packOf(currentVariantId());
        var preferred = null;
        state.packs.forEach(function (pack) {
          if (pack.id === data.defaultPack) preferred = pack;
        });
        var start = /[?&]variant=/.test(window.location.search) && owner ? owner : preferred || owner || state.packs[0];
        state.pack = start.id;
        info.classList.add('hm-has-variant-packs');
        var pack = current();
        if (pack) moveToPack(pack);
        ensure();
        observer.observe(info.parentNode || info, { childList: true, subtree: true });
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
